<template>
    <div>
        <BlockCategorySearchBoxDropdown :type='categoryName' />
		<BlockFilter :productType='categoryName' />
        <BlockProductListing />
    </div>
</template>

<script>
    import BlockCategorySearchBoxDropdown from './BlockCategorySearchBoxDropdown.vue';
    import BlockProductListing from './BlockProductListing.vue';
    import BlockFilter from './BlockFilter.vue';
    export default {
        components: {
			BlockProductListing,
			BlockCategorySearchBoxDropdown,
			BlockFilter
		},
		data() {
			return {
				// eslint-disable-next-line no-undef
				productCategory: productCategory,
				// eslint-disable-next-line no-undef
				categoryName: categoryName
			};
		}
    };
</script>

<style lang="scss" scoped>

</style>
